import { SET_SHOW_GEOCODE_RESULTS } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (value) => creditFileActions[SET_SHOW_GEOCODE_RESULTS](value);
